import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IRACING_AUTH_LOGIN_URL } from "../utils/iracingAuthApi";
import "../styles/LoginPage.css";

export const LoginPage = ({ setIsLoggedIn }) => {
        const [username, setUsername] = useState("");
        const [password, setPassword] = useState("");
        const navigate = useNavigate();

        const handleLogin = async () => {
                // Check if the username and password fields are not empty
                if (!username || !password) {
                        alert("Please enter a valid username and password.");
                        return;
                }

                try {
                        // Make an API call to authenticate the user
                        const response = await fetch("https://iracing6-backend.herokuapp.com/api/user-login/login", {
                                method: "POST",
                                headers: {
                                        "Content-Type": "application/json",
                                },
                                body: JSON.stringify({ username, password }),
                        });

                        const data = await response.json();

                        if (response.status === 200) {
                                localStorage.setItem("token", data.token);
                                localStorage.setItem("username", data.username);
                                localStorage.setItem("isPaidUser", data.isPaidUser); // Save this field in the local storage
                                setIsLoggedIn(true);
                                navigate("/");
                        } else {
                                alert(data.message);
                        }
                } catch (error) {
                        console.error("Error logging in:", error);
                        alert("An error occurred. Please try again.");
                }
        };

        return (
                <div className="login-page">
                        <h2>Login</h2>
                        <button
                                type="button"
                                className="iracing-signin-btn"
                                onClick={() => { window.location.href = IRACING_AUTH_LOGIN_URL; }}
                        >
                                <img
                                        src="/iRacing-Icon-BW-White.png"
                                        alt=""
                                        className="iracing-signin-logo"
                                />
                                <span>Sign in with iRacing</span>
                        </button>
                        <div className="iracing-login-divider">or</div>
                        <p className="login-note">Local website account — separate from your iRacing.com credentials.</p>
                        <form className="login-form" onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                                <input type="text" placeholder="Email" value={username} onChange={(e) => setUsername(e.target.value)} />
                                <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                <button type="submit">Login</button>
                        </form>
                        <div className="forgot-password-link">
                                <div onClick={() => navigate("/forgot-password")} className="forgot_pword">
                                        Forgot Password?
                                </div>
                        </div>
                        <div className="register-link">
                                Don't have an account?{" "}
                                <button onClick={() => navigate("/register")} className="regist-buttn">
                                        Register
                                </button>
                        </div>
                </div>
        );
};
